import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export interface AiChatMessage {
  role: 'user' | 'assistant';
  content: string;
  timestamp?: Date;
  data?: any;
  actions?: Array<{
    label: string;
    action: string;
    params?: Record<string, any>;
  }>;
}

export interface AiChatResponse {
  sessionId: string;
  message: string;
  data?: any;
  actions?: Array<{
    label: string;
    action: string;
    params?: Record<string, any>;
  }>;
}

/**
 * AI Assistant Service
 * Handles communication with the AI assistant backend for authenticated users
 */
export const aiAssistantService = {
  /**
   * Send a message to the AI assistant
   */
  sendMessage: async (message: string, sessionId?: string): Promise<AiChatResponse> => {
    const { data } = await axios.post<AiChatResponse>(`${API}/ai-assistant/chat`, {
      message,
      sessionId,
    });
    return data;
  },

  /**
   * Get session history
   */
  getSessionHistory: async (sessionId: string): Promise<{
    sessionId: string;
    messages: AiChatMessage[];
    createdAt: string;
  } | null> => {
    try {
      const { data } = await axios.get(`${API}/ai-assistant/session/${sessionId}`);
      return data;
    } catch (error) {
      return null;
    }
  },

  /**
   * Clear session history
   */
  clearSession: async (sessionId: string): Promise<boolean> => {
    try {
      const { data } = await axios.delete(`${API}/ai-assistant/session/${sessionId}`);
      return data.success;
    } catch (error) {
      return false;
    }
  },
};

/**
 * Property Search Chat Service
 * Handles communication with the chat endpoint for property search
 */
export const propertySearchService = {
  /**
   * Send a search message
   */
  sendMessage: async (message: string, sessionId?: string): Promise<{
    session_id: string;
    message: string;
    criteria: any;
    properties: any[];
    propertyCount: number;
  }> => {
    const { data } = await axios.post(`${API}/chat/message`, {
      message,
      sessionId: sessionId,
    });
    return data;
  },

  /**
   * Get session
   */
  getSession: async (sessionId: string): Promise<any> => {
    const { data } = await axios.get(`${API}/chat/sessions/${sessionId}`);
    return data;
  },
};

export default aiAssistantService;

